import * as React from "react";

import ImageGallery from "../ImageGallery/ImageGallery";
import { ImageSlide } from "../ImageGallery/types";

/**
 * Wrapper for ImageGallery that conditionally hides the thumbnails
 * @param props
 * @returns
 */
export const HgsImageGallery: React.FC<{ items: ImageSlide[] }> = (props) => {
  let showThumbnails = true;
  if (props.items.length < 2) {
    showThumbnails = false;
  }
  return (
    <ImageGallery
      items={props.items}
      showPlayButton={false}
      showThumbnails={showThumbnails}
    ></ImageGallery>
  );
};
